
import { Options, Vue } from 'vue-class-component'
import Logger from '@/util/logger'

/**
 * @author Ahto Jalak
 * @since 06.02.2023
 */
@Options({
    components: {},
    props: {
        id: String
    },
    emits: [],
})
export default class WatchlistEdit extends Vue {
    private logger = new Logger(WatchlistEdit.name)
    id!: string
}
